import { render, staticRenderFns } from "./ClubImg.vue?vue&type=template&id=0367baf8"
import script from "./ClubImg.vue?vue&type=script&lang=js"
export * from "./ClubImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports